import type { District } from "../world/districts";

export const HOME_STATIC_SCENE_PATH =
  "/world/home-real3d/v3/home-real3d-static.webp";
export const HOME_STATIC_SCENE_SHA256 =
  "6121bd751a0f5928736ce09e996e43a8c7095f7af4e126291ffb1abd09925beb";
export const HOME_STATIC_MOBILE_SCENE_PATH =
  "/world/home-real3d/v3/home-real3d-mobile.webp";
export const HOME_STATIC_MOBILE_SCENE_SHA256 =
  "0527928e0402d6ed161263fb083d026fbd60dc93e22ce74fa60773d7c30772e0";
export const HOME_ENTER_PENDING_KEY = "dgc.home.enter.pending.v1";
export const HOME_ENTER_EVENT = "dgc:home-enter";
export const HOME_ROUTE_WAKE_EVENT = "dgc:home-route-wake";
export const HOME_JOURNEY_DATASET = "homeJourney";

export function staticSceneUrl(
  district: Pick<District, "districtId" | "outputPath">,
) {
  return district.districtId === "garden-commons"
    ? HOME_STATIC_SCENE_PATH
    : "/" + district.outputPath;
}

export function staticSceneMobileUrl(
  district: Pick<District, "districtId">,
) {
  return district.districtId === "garden-commons"
    ? HOME_STATIC_MOBILE_SCENE_PATH
    : undefined;
}
